import { Outlet } from "react-router-dom";

import logo from "@fronterahealth/frontera-ui-components/assets/logo.svg";

export const PublicNavBar: React.FC = () => {
  return (
    <div>
      <div className="fixed top-0 left-0 right-0 z-50 flex h-12 sm:h-14 items-center justify-between border-b border-limestone-100 bg-white px-4 py-3 sm:px-6 sm:py-4">
        <img className="h-5 sm:h-6" data-testid="logo-img" src={logo} alt="Frontera Logo" />

        <div className="flex flex-row items-center gap-2 sm:gap-4">
          <a className="text-limestone-900 text-xs sm:text-sm" href="https://www.fronterahealth.com">
            Learn about Frontera
          </a>

          {/* TODO: support page */}
          <a className="text-limestone-900 text-xs sm:text-sm" href="/support">
            Support
          </a>
        </div>
      </div>

      <div className="pt-12 sm:pt-14">
        <Outlet />
      </div>
    </div>
  );
};
